import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'manualCorrectionHtml'
})
export class ManualCorrectionHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    let html = text;
    if (!/<[a-z][\s\S]*>/i.test(text)) {
      html = text.replace(/\n/g, '<br>');
    }

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
